/* eslint-disable react/style-prop-object */
import React, { useState } from "react";
import { Input } from "../../Helpers/Input/Input";
import Button from "../../Helpers/Button/Button";
import { toast } from "react-toastify";
import trans from "../../../utils";
import usePermission from "../../../hooks/usePermission";
import useIsMobile from "../../../hooks/useIsMobile";

export default function AccountLocation({ inf, disable, formValidation }) {
  const isMobile = useIsMobile();
  const [location, setLocation] = useState();

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });

          // Update the `inf` values directly
          inf.setFieldValue("latitude", latitude);
          inf.setFieldValue("longitude", longitude);
        },
        (error) => {
          toast.error(trans("Error: Unable to retrieve location"), {
            autoClose: 800,
            rtl: localStorage.getItem("lang") === "ar" ? true : false,
          });
        },
      );
    } else {
      toast.info(trans("Geolocation not supported"), {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar" ? true : false,
      });
    }
  };

  // Get values for rendering
  let lat = location?.latitude ? location.latitude : inf.values.latitude;
  let lon = location?.longitude ? location.longitude : inf.values.longitude;
  const { create, edit } = usePermission("SETUPACCOUNT");

  return (
    <div className="account-layout account-location">
      <div className="account-layout-head">{trans("Location")}</div>
      <p className="account-layout-title">
        {trans("Update your current location.")}
      </p>
      <div className="row">
        <div className="col-12 col-lg-4">
          <Input
            title={trans("Latitude")}
            type="text"
            placeholder="90"
            formstyle="form-input"
            id="latitude"
            name="latitude"
            onBlur={inf.handleBlur}
            onChange={inf.handleChange}
            errors={inf.errors.latitude}
            touched={inf.touched.latitude}
            value={lat || ""}
            disabled={!create || !edit}
          />
        </div>
        <div className="col-12 col-lg-4">
          <Input
            title={trans("Longitude")}
            type="text"
            placeholder="180"
            formstyle="form-input"
            id="longitude"
            name="longitude"
            onBlur={inf.handleBlur}
            onChange={inf.handleChange}
            errors={inf.errors.longitude}
            touched={inf.touched.longitude}
            value={lon || ""}
            disabled={!create || !edit}
          />
        </div>
        {(create || edit) && (
          <div className="col-12 col-lg-4">
            {isMobile ? (
              <>
                <Button
                  text={trans("Get Current Location")}
                  type="default"
                  onClick={getLocation}
                  className={"w-100"}
                />
                {edit && (
                  <div className="flex-between">
                    <Button
                      text={trans("Save Changes")}
                      type="primary"
                      htmlType="submit"
                      className={"w-100 mt-8"}
                      disabled={disable || formValidation}
                    />
                  </div>
                )}
              </>
            ) : (
              <Button
                text={trans("Get Current Location")}
                className="by-100"
                type="default"
                onClick={getLocation}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
